import { render, staticRenderFns } from "./VisitCauses.vue?vue&type=template&id=2a0f11fd&"
import script from "./VisitCauses.vue?vue&type=script&lang=js&"
export * from "./VisitCauses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports